import React, { useEffect, useState } from 'react'
import { SalesService } from 'lib/api'
import { Grid } from '@material-ui/core'
import { WorkListEstimateCardDesktop } from './WorkListEstimateCard.desktop'
import { NotFound } from 'components/NotFound'
import { WorkListEstimateCardMobile } from './WorkListEstimateCard.mobile'
import { useWorkListViewRopStore } from 'context/WorkListViewStore/Rop/WorkListViewStore.rop'
import { InfoModal } from 'asterX-UI/Modals'
import { FieldInfoNG } from 'asterX-UI/DataDisplay'
import AsterTypography from 'asterX-UI/Typography/AsterTypography'
import moment from 'moment/moment'

const isMobile = window.innerWidth <= 768

export const WorkListEstimate = ({ client: { phoneNumber } }) => {
  const {
    actions: { setLoading }
  } = useWorkListViewRopStore()

  const [wlAssessments, setWlAssessments] = useState(null)

  const [resultOpen, setResultOpen] = useState(false)
  const [purchaserOpen, setPurchaserOpen] = useState(false)
  const [currentAssesment, setCurrentAssesment] = useState(null)

  const handleOpenResult = assessment => {
    setCurrentAssesment(assessment)
    setResultOpen(true)
  }

  const handleOpenPurchaser = assessment => {
    setCurrentAssesment(assessment)
    setPurchaserOpen(true)
  }

  useEffect(() => {
    if (phoneNumber) {
      setLoading(true)
      SalesService.getDealsByPhone(phoneNumber)
        .then(res => {
          if (res?.data?.list) {
            setWlAssessments(res.data?.list || [])
          }
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }, [phoneNumber])

  return (
    <Grid container>
      {wlAssessments?.length ? (
        wlAssessments.map((e, i) =>
          isMobile ? (
            <WorkListEstimateCardMobile
              key={`work-list-estimate-${i}`}
              assessment={e}
              isLast={wlAssessments.length - 1 === i}
              onClick={handleOpenResult}
              onClickPurchaser={handleOpenPurchaser}
            />
          ) : (
            <WorkListEstimateCardDesktop
              key={`work-list-estimate-${i}`}
              assessment={e}
              isLast={wlAssessments.length - 1 === i}
              onClick={handleOpenResult}
              onClickPurchaser={handleOpenPurchaser}
            />
          )
        )
      ) : (
        <NotFound title="Нет РЛ оценки" />
      )}

      <InfoModal
        open={resultOpen}
        onClose={() => setResultOpen(false)}
        title="Результат оценки"
        hasIcon={false}
        withoutButton
      >
        <FieldInfoNG label="Дата/время" labelStyle={{ minWidth: 81 }}>
          <AsterTypography>
            {currentAssesment?.createdDate
              ? moment(currentAssesment?.createdDate).format('DD MMM YYYY')
              : '-'}
          </AsterTypography>
        </FieldInfoNG>
        <FieldInfoNG labelStyle={{ minWidth: 81 }} label="Результат">
          <AsterTypography>{currentAssesment?.comment || '-'}</AsterTypography>
        </FieldInfoNG>
      </InfoModal>
    </Grid>
  )
}
